import React from 'react';

import styles from './task-property.button.module.scss';

interface TaskPropertyButtonProps {
  label?: string;

  icon?: React.ReactElement;

  onClick?: () => void;

  isActive?: boolean;

  isDisabled?: boolean;

  ref?: React.RefObject<HTMLButtonElement>;
}

export const TaskPropertyButton: React.FC<TaskPropertyButtonProps> = ({
  label,
  icon,
  onClick,
  isActive,
  isDisabled,
  ref,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick && onClick();
  };

  return (
    <button
      // Property buttons are rendered inside the create-task `<form>`; without an explicit type a
      // native button defaults to `type="submit"`, so opening a property's modal submitted the
      // form and created the task early, dropping the value being picked (PRO-1078).
      type="button"
      ref={ref}
      className={styles.button}
      data-is-active={isActive}
      disabled={isDisabled}
      onClick={handleClick}
    >
      {icon}
      {label}
    </button>
  );
};
